import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import FormikControl from "../../formikcontrols";
// import './MasterModal.scss'
import "./UserModal.scss";
import { privateRequest } from "../../../api/apiConfig/privateRequest";
import {
  designationOptionsUtility,
  languageOptionsUtility,
  rolesOptionsUtility,
  technologyOptionsUtility,
  vendorNameList,
} from "../../../customHooks";
import { emailRegex } from "../../../utils/validation";

const UserMasterModal = ({
  isOpen,
  closeModal,
  title,
  data,
  addData,
  updateData,
}) => {
  const [error, setError] = useState("");
  const [technicalstack, setTechnicalstack] = useState([]);
  const [designationOption, setdesignationOption] = useState();
  const [roleoptions, setRoleoptions] = useState([]);
  const [languageOptions, setLangaugeOptions] = useState([]);
  const [iscondition, setIscondition] = useState(false);
  const [vendorsName, setVendorsName] = useState([]);
  const initialValues = {
    name: "",
    email: "",
    dob: "",
    address: "",
    highestQualification: "",
    universityName: "",
    yearOfPassing: "",
    dateOfJoining: "",
    designationId: "",
    careerStartDate: "",
    gender: "",
    //roles:[],
    technicalStack: [],
    summary: "",
    laptopConfiguration: "",
    vendor: "",
    resourceType: "",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "You have entered an invalid email address!")
      .required("Email is required")
      .nullable(),
    summary: Yup.string().max(300, "Summary allow only 300 character"),
  });
  const handleSubmit = async (values) => {
    if (data === undefined) {
      addData({ ...values, yearOfPassing: parseInt(values.yearOfPassing) });
      closeModal();
    } else {
      if (data == values) {
        setError("Please Change The Value");
      } else {
        delete values["roles"];
        updateData(values);
        // updateData({...values,roles:[values.roles]})
        closeModal();
      }
    }
  };

  const getLanguageOptions = async () => {
    const options = await technologyOptionsUtility("name", "name");
    setLangaugeOptions(options);
  };

  const genderOptions = [
    { label: "Male", value: "MALE" },
    { label: "Female", value: "FEMALE" },
  ];

  const resourceOption = [
    { label: "Internal", value: "INTERNAL" },
    { label: "External", value: "EXTERNAL" },
  ];
  const getDesignationOptions = async () => {
    const options = await designationOptionsUtility("name", "id");
    setdesignationOption(options);
  };
  const getstacks = async () => {
    const { data } = await privateRequest.get("/project/stacks");
    setTechnicalstack(data.data);
  };

  const handleChange = (value) => {};
  const getVendorsName = async () => {
    const options = await vendorNameList("name", "name");
    setVendorsName(options);
  };

  const showVendorOptions = () => {
    setIscondition(false);
  };

  useEffect(() => {
    // getRole()
    getstacks();
    //getUserData()
    getLanguageOptions();
    getDesignationOptions();
    getVendorsName();
  }, []);
  return (
    <div className="user_modal">
      <Modal
        show={isOpen}
        onHide={isOpen}
        dialogClassName="userModal"
        contentClassName="userContent"
        backdropClassName="userBackdrop"
        centered
        size="lg"
      >
        <Modal.Header>
          <span className="user_modal__sec--head">
            {data === undefined ? "Add" : "Edit"} {title}
          </span>
        </Modal.Header>
        <Modal.Body style={{ overflow: "scroll", height: 500 }}>
          <Formik
            initialValues={data === undefined ? initialValues : data}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => {
              return (
                <>
                  <Form className="user_modal__sec--body-form">
                    {/* {console.log("values", formik.values, formik.errors)} */}

                    <FormikControl
                      control="select"
                      options={resourceOption}
                      form={formik}
                      label="Resources Type"
                      name="resourceType"
                    />

                    {formik.values.resourceType == "EXTERNAL" && (
                      <FormikControl
                        isMulti={true}
                        control="select"
                        options={vendorsName}
                        form={formik}
                        label="Vendor"
                        name="vendor"
                      />
                    )}

                    <FormikControl
                      control="input"
                      label="Full Name"
                      name="name"
                    />
                    <FormikControl
                      control="input"
                      label="Email"
                      name="email"
                      required={true}
                    />

                    <FormikControl
                      isMulti={true}
                      control="select"
                      label="Technology"
                      form={formik}
                      options={languageOptions}
                      name="technicalStack"
                    />
                    <FormikControl control="date" label="DOB" name="dob" />
                    <FormikControl
                      control="select"
                      label="Designation"
                      form={formik}
                      options={designationOption}
                      name="designationId"
                    />
                    <FormikControl
                      control="select"
                      options={genderOptions}
                      form={formik}
                      label="Gender"
                      name="gender"
                    />

                    <FormikControl
                      control="input"
                      label="Highest Qualification"
                      name="highestQualification"
                    />

                    <FormikControl
                      control="input"
                      label="University"
                      name="universityName"
                    />

                    <FormikControl
                      control="input"
                      label="Year of Passing"
                      name="yearOfPassing"
                    />
                    <FormikControl
                      control="date"
                      label="Date of joining"
                      name="dateOfJoining"
                    />

                    <FormikControl
                      control="date"
                      label="Career Start Date"
                      name="careerStartDate"
                    />

                    <FormikControl
                      control="textarea"
                      label="Summary"
                      name="summary"
                      placeholder="Allow only 300 character"
                      maxLength="300"
                    />

                    <FormikControl
                      control="textarea"
                      label="Address"
                      name="address"
                    />

                    <FormikControl
                      control="input"
                      label="Laptop Configuration"
                      name="laptopConfiguration"
                    />

                    <Modal.Footer className="user_modal__sec--body-form-bottom">
                      <Button className="user_modal__sec--btn" type="submit">
                        {data === undefined ? "Add" : "Update"}
                      </Button>
                      <Button
                        className="user_modal__sec--btn modal__sec--btn-close"
                        onClick={closeModal}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Form>
                  <div className="errormsg">{error}</div>
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UserMasterModal;
